import React from 'react';
import Modal from '../Modal';
import SingleUpload from '../SingleUpload';

class FileInput extends React.Component {
  localChange = (value) => {
    this.props.onChange({[this.props.column.name]: value});
  }

  state = {
    show: false
  };

  showModal = e => {
    this.setState({
      show: !this.state.show
    });
  };

  render() {
    return (
      <div className="form-group col-md-12">
        <label htmlFor={this.props.column.name}>{this.props.column.label}</label>
        <br/>
        {this.props.value} &nbsp;
        <button
          className="toggle-button"
          id="centered-toggle-button"
          onClick={e => {
            this.showModal(e);
          }}
        >
          {" "}{this.props.value ? 'Change Photo' : 'Upload Photo'}{" "}
        </button>
        <Modal onClose={this.showModal} show={this.state.show} title={this.props.column.label}>
          <SingleUpload afterUpload={this.localChange}/>
        </Modal>
      </div>
    );
  }
}

export default FileInput;
